import type { SourceConnection } from "./sourceConnectionsApi";
import type { ThreadDisplayStatus } from "../../threads/status/threadStatus";

export type UpdateStatus = "up_to_date" | "update_available" | "pending" | "waiting_for_host" | "waiting_for_approval" | "running" | "waiting_for_you" | "proposed" | "failed";

export interface UpdateThread {
  /** The update Thread's one status, as the Thread list shows it: a failed step or a waiting human step counts. */
  readonly status: ThreadDisplayStatus;
  readonly connectorOnline: boolean;
}

/** Only the request for the current upstream describes this update; older runs are history. */
export function latestUpdateRequest(connection: SourceConnection) {
  return connection.requests.find((request) => request.newCommit === connection.upstream) ?? null;
}

export function connectionStatus(connection: SourceConnection, thread: UpdateThread | null): UpdateStatus {
  const partial = connection.importedSelection != null;
  if (connection.upstream === null || (connection.upstream === connection.imported && !partial)) return "up_to_date";
  const request = latestUpdateRequest(connection);
  if (request === null) return partial || connection.policy === "on_demand" ? "update_available" : "pending";
  if (request.state === "pending") return "pending";
  if (request.state === "failed" || request.state === "proposed") return request.state;
  switch (thread?.status) {
    case "closed":
    case "failed":
      return "failed";
    case "input":
      return "waiting_for_you";
    case "working":
    case "waiting":
    case "live":
      return "running";
    case "approval":
      return "waiting_for_approval";
    case "saved":
      return thread.connectorOnline ? "pending" : "waiting_for_host";
    case undefined:
      return "pending";
  }
}
